import gql from "graphql-tag";
import LockableCommentFields from "../../fragments/LockableCommentFields";

export default gql`
  mutation UnlockAssetDiscussionComment($commentId: ObjectID!) {
    unlockAssetDiscussionComment(commentId: $commentId) {
      __typename
      _id
      ...LockableCommentFields
    }
  }

  ${LockableCommentFields}
`;
